import type { PropertyFilterProps } from '@risk-smart/themed-cloudscape-components/property-filter';
import PropertyFilter from '@risk-smart/themed-cloudscape-components/property-filter';
import type { FC } from 'react';
import { useMemo, useState } from 'react';

import styles from './style.module.scss';

// Cloudscape's built-in autosuggest filter (see node_modules
// @cloudscape-design/components/property-filter/filter-options.js
// `matchSingleOption`) matches the typed search text against
// `label || value`. For dropdowns like Owner and Tags the `value`
// is a UUID, so typing a digit or short string matches the hex/digit
// content of the UUID — producing a list of unrelated names/tags
// (RSP-5284). Pre-filter the options by label BEFORE handing them to
// Cloudscape so the UUID value can no longer contaminate the match.
const PropertyFilterPanel: FC<PropertyFilterProps> = ({
  filteringOptions,
  onLoadItems,
  ...rest
}) => {
  const [filteringText, setFilteringText] = useState('');
  const [filteringPropertyKey, setFilteringPropertyKey] = useState<
    string | undefined
  >(undefined);

  const visibleOptions = useMemo(() => {
    if (!filteringOptions || !filteringText || !filteringPropertyKey) {
      return filteringOptions;
    }
    const needle = filteringText.toLowerCase();

    return filteringOptions.filter((option) => {
      if (option.propertyKey !== filteringPropertyKey) {
        return true;
      }
      const label = (option.label ?? '').toLowerCase();

      return label.includes(needle);
    });
  }, [filteringOptions, filteringText, filteringPropertyKey]);

  return (
    <div className={styles.propertyFilter}>
      <PropertyFilter
        {...rest}
        filteringOptions={visibleOptions}
        onLoadItems={(event) => {
          setFilteringText(event.detail.filteringText ?? '');
          setFilteringPropertyKey(event.detail.filteringProperty?.key);
          onLoadItems?.(event);
        }}
      />
    </div>
  );
};

export default PropertyFilterPanel;
